export default {
      id: "PushpayLogo-usage",
      viewBox: "0 0 204 56",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#PushpayLogo",
      toString: function () {
        return this.url;
      }
    }